import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Testids } from '@mono/ui-selectors';
import { cn } from '../../../lib/utils';
import { SpecraAvatar } from '../ensigns/avatar';
import { SpecraLogo } from '../ensigns/logo';
import { SpecraText } from '../ensigns/typography';
/** Author frame for user and assistant conversation content. */ export function SpecraChatMessage({ actions, author, children, className, showAuthor = true, speaker, timestamp, ...props }) {
    return /*#__PURE__*/ _jsxs("article", {
        className: cn('flex items-start gap-3', className),
        ...props,
        children: [
            speaker === 'assistant' ? /*#__PURE__*/ _jsx("span", {
                "data-testid": Testids.assistant.messageAvatar,
                className: "flex size-8 shrink-0 items-center justify-center rounded-full bg-muted",
                children: /*#__PURE__*/ _jsx(SpecraLogo, {
                    size: 20,
                    variant: "mark",
                    label: "Assistant"
                })
            }) : /*#__PURE__*/ _jsx(SpecraAvatar, {
                "data-testid": Testids.assistant.messageAvatar,
                name: author,
                size: 32
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "min-w-0 flex-1 pt-0.5",
                children: [
                    showAuthor ? /*#__PURE__*/ _jsxs("div", {
                        className: "flex items-baseline gap-2",
                        children: [
                            /*#__PURE__*/ _jsx(SpecraText, {
                                className: "font-medium",
                                size: "caption",
                                children: author
                            }),
                            timestamp ? /*#__PURE__*/ _jsx(SpecraText, {
                                size: "micro",
                                tone: "muted",
                                children: timestamp
                            }) : null
                        ]
                    }) : null,
                    /*#__PURE__*/ _jsx("div", {
                        className: cn('text-[length:var(--fs-ui-emphasis)] leading-[var(--lh-body)] text-foreground', showAuthor && 'mt-1 text-[length:var(--fs-ui)] leading-relaxed text-foreground/90'),
                        children: children
                    }),
                    actions ? /*#__PURE__*/ _jsx("div", {
                        className: "mt-2 flex flex-wrap items-center gap-1",
                        children: actions
                    }) : null
                ]
            })
        ]
    });
}
